<template>
  <ButtonPlaceholder v-if="props.isProcessing"></ButtonPlaceholder>
  <template v-else>
    <template v-if="User.signedIn()">
      <Dialog v-if="store.selectedImage.hdResult.state !== ProcessingState.Finished" trigger-classes="w-full focus:outline-none" :on-open="props.loadCreditsAndUpdatePreview">
        <template #trigger>
          <Button :disabled="!props.enableDownloadHdButton" variant="secondary" :loading="props.isProcessingHdDownload" full-width>{{ I18n.t("image.download_high_res") }}</Button>
        </template>
        <template v-slot:content="{ closeDialog }">
          <div class="flex flex-col gap-y-6 w-full">
            <div class="flex flex-col gap-y-0 mt-3">
              <Heading level="h4">{{ I18n.t("image.download_high_res") }}</Heading>
              <p class="!m-0 text-xl text-brand-typo font-bold">HD {{ store.selectedImage.meta.hdWidth }}x{{ store.selectedImage.meta.hdHeight }}px</p>
            </div>

            <div class="sm:w-128 rounded-lg !bg-secondary border !border-secondary">
              <HTMLImage v-if="store.selectedImage.meta.orientation === ImageOrientation.Portrait" :src="store.selectedImage.meta.livePreview" alt="" width="200" :fluid="false" img-classes="bg-white checkerboard rounded-lg mx-auto" />
              <HTMLImage v-else :src="store.selectedImage.meta.livePreview" alt="" :fluid="false" img-classes="!w-full bg-white checkerboard rounded-lg mx-auto" />
            </div>

            <div class="flex flex-col gap-y-3 justify-center">
              <div class="text-center">
                <Button class="mb-2" size="lg" type="submit" :disabled="credits <= 0" @click.prevent="() => props.downloadHd(closeDialog)">{{ I18n.t("image.download_high_res_for_1_credit") }}</Button>
              </div>
              <div class="flex justify-center items-center space-x-4">
                <p class="!m-0 text-typo">You have {{ props.credits }} credits</p>
                <a class="" :href="Routes.get('pricing_url')">{{ I18n.t("full_image.get_credits") }}</a>
              </div>
            </div>
          </div>
        </template>
      </Dialog>
      <Button v-else variant="secondary" @click.prevent="() => props.downloadHd()" :loading="isProcessingHdDownload" full-width>{{ I18n.t("image.download_high_res") }}</Button>
    </template>
    <template v-else>
      <Dialog trigger-classes="w-full focus:outline-none">
        <template v-slot:trigger>
          <Button variant="secondary" full-width>{{ I18n.t("image.download_high_res") }}</Button>
        </template>
        <template v-slot:content="{ closeDialog }">
          <div class="flex flex-col gap-y-6 w-full">
            <div class="flex flex-col gap-y-0 mt-3">
              <Heading level="h4">{{ I18n.t("image.download_high_res_image") }}</Heading>
              <p class="!m-0 text-xl text-brand-typo font-bold">HD {{ store.selectedImage.meta.hdWidth }}x{{ store.selectedImage.meta.hdHeight }}px</p>
            </div>

            <div class="sm:w-128 rounded-lg !bg-secondary border !border-secondary">
              <HTMLImage v-if="store.selectedImage.meta.orientation === ImageOrientation.Portrait" :src="store.selectedImage.meta.livePreview" alt="" width="200" :fluid="false" img-classes="bg-white checkerboard rounded-lg mx-auto" />
              <HTMLImage v-else :src="store.selectedImage.meta.livePreview" alt="" :fluid="false" img-classes="!w-full bg-white checkerboard rounded-lg mx-auto" />
            </div>

            <div class="flex flex-col gap-y-3 justify-center">
              <p class="!m-0 text-xl text-typo font-bold text-center">{{ I18n.t("full_image.get_this_free") }}:</p>
              <div class="text-center">
                <Button as="link" :href="Routes.get('signup_url')" size="lg" autofocus>{{ I18n.t("full_image.sign_up_free") }}</Button>
              </div>
              <div class="flex gap-2 justify-center">
                <span>{{ I18n.t("full_image.already_have_account") }}</span
                ><Link hideArrow :href="Routes.get('login_url')">{{ I18n.t("full_image.login") }}</Link>
              </div>
            </div>
          </div>
        </template>
      </Dialog>
    </template>
  </template>
</template>
<script setup lang="ts">
import "@/src/i18n";
import { useEditorStore } from "@/stores/editor_store";
import { ImageOrientation } from "@/modules/internal_api/image";
import Routes from "@/modules/routes";
import { inject } from "vue";
import User from "@/modules/user";
import { ProcessingState } from "@/modules/internal_api/image";
import { Dialog, Button, Image as HTMLImage, Heading, Link, ButtonPlaceholder } from "prism";

const I18n = inject("I18n");

const store = useEditorStore();

interface DownloadHdDialogProps {
  editor: any;
  enableDownloadHdButton: Boolean;
  isProcessing: Boolean;
  isProcessingHdDownload: Boolean;
  isProcessingPreviewDownload: Boolean;
  credits: any;
  loadCreditsAndUpdatePreview: any;
  downloadHd: any;
}

const emit = defineEmits<{
  (e: "closeDialog"): void;
}>();

const closeDialog = () => {
  emit("closeDialog");
};

const props = defineProps<DownloadHdDialogProps>();
</script>
